import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "text-left"
};
var _hoisted_2 = {
  class: "text-left lh-25"
};
var _hoisted_3 = {
  key: 0,
  class: "flex lh-25"
};
var _hoisted_4 = {
  class: "text-left"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "blk_link cursor-pointer"
};
var _hoisted_7 = {
  key: 0,
  class: "more-bom-info"
};
var _hoisted_8 = {
  class: "plus-items"
};
var _hoisted_9 = {
  key: 1,
  class: "expand-toggle"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  key: 1,
  class: "no-logs"
};
import { ref, reactive } from "vue";
import router from "@/router";
export default {
  __name: 'timelog',
  props: {
    logs: {
      type: Array,
      default: () => []
    },
    notxt: {
      type: String,
      default: "暂无日志"
    }
  },
  setup(__props) {
    var props = __props;

    // 记录每个日志项的展开状态
    var expandedItems = reactive({});

    // 切换展开/收起状态
    var toggleExpand = id => {
      expandedItems[id] = !expandedItems[id];
    };

    // 根据展开状态决定显示哪些 bom 项
    var visibleBoms = (boms, logId) => {
      if (expandedItems[logId]) {
        return boms;
      } else {
        return boms.slice(0, 2); // 只显示前两项
      }
    };
    var tobom = id => {
      router.push("/work_bench/bomadd?id=" + id);
    };
    return (_ctx, _cache) => {
      var _component_el_card = _resolveComponent("el-card");
      var _component_el_timeline_item = _resolveComponent("el-timeline-item");
      var _component_el_timeline = _resolveComponent("el-timeline");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.logs.length > 0 ? (_openBlock(), _createBlock(_component_el_timeline, {
        key: 0
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.logs, (v, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: index,
            timestamp: v.created_at,
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.log.content, (m, n) => {
                return _openBlock(), _createElementBlock("div", {
                  key: n
                }, [_createElementVNode("p", _hoisted_2, _toDisplayString(m), 1)]);
              }), 128)), v.log && v.log.bom && v.log.bom[0] ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", null, "替换bom：", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBoms(v.log.bom, v.id), (m, n) => {
                return _openBlock(), _createElementBlock("div", {
                  onClick: $event => tobom(m.bom_id),
                  key: n,
                  class: "bom-item"
                }, [_createElementVNode("span", _hoisted_6, _toDisplayString(m.code), 1), _cache[0] || (_cache[0] = _createTextVNode("   ")), _createElementVNode("span", null, _toDisplayString(m.desc), 1)], 8, _hoisted_5);
              }), 128)), v.log.bom.length > 2 && !expandedItems[v.id] ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, "+" + _toDisplayString(v.log.bom.length - 2) + "项", 1)])) : _createCommentVNode("", true), v.log.bom.length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", {
                class: "blk_link cursor-pointer",
                onClick: _withModifiers($event => toggleExpand(v.id), ["stop"])
              }, _toDisplayString(expandedItems[v.id] ? '收起' : '展开'), 9, _hoisted_10)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["timestamp"]);
        }), 128))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.notxt || "暂无操作日志"), 1))]);
    };
  }
};